(() => {
    const gender = window.genderPreference.getGenderPreference();
    const {language, country} = document.body.dataset;

    if (gender && window.genderPreference.AVAILABLE_GENDERS.includes(gender)) {
        if (country === 'it') {
            window.location.href = `/collections/${gender}`;
        } else {
            window.location.href = `/${language}-${country}/collections/${gender}`;
        }
    }
})();